<template>
    <v-dialog v-model="active" width="600">
        <v-card>
            <v-card-title>Reject this suggestion?</v-card-title>
            <v-card-text>

                <v-col cols="12">
                    <template v-if="suggestion">

                        <v-list-item-title class="text--h4 mb-3">
                            <v-chip color="primary" class="mr-2">Suggestion</v-chip>
                            {{ suggestion.message }}
                        </v-list-item-title>

                        <div class="orange--text ml-5">
                            <v-list-item-subtitle v-if="suggestion.up_to_hand_num">Valid to Hand #{{ suggestion.up_to_hand_num }}</v-list-item-subtitle>
                            <v-list-item-subtitle v-if="suggestion.up_to_ts">Valid for {{ Math.round(suggestion.up_to_ts - ((+(new Date()))/1000)) }}s</v-list-item-subtitle>
                        </div>
                    </template>
                </v-col>

                <v-col cols="12">
                    <v-textarea
                        v-model="reason"
                        outlined hide-details
                        label="Reason (required)"
                    ></v-textarea>
                </v-col>

            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red" text @click="rejectSuggestion();" :disabled="reason.length <= 3">Confirm</v-btn>
                <v-btn text @click="close">Cancel</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

export default {
    name: "RejectSuggestion",

    data() {
        return {
            reason: "",
            active: false,
            suggestion: null,
        }
    },

    computed: {

    },

    mounted() {

    },

    methods: {
        open(suggestion) {
            console.log('open', suggestion)
            this.reason = "";
            this.suggestion = suggestion;
            this.active = true;
        },

        close() {
            this.active = false;
        },

        rejectSuggestion() {
            this.$axios.post(`/api/chatbot/${this.suggestion.id}/reject`, {
                reason: this.reason
            }).then(() => {
                this.close();
            }).catch((error) => {
                console.log(error);
            });
        }
    }
}
</script>

<style scoped>

</style>
